export default "__VITE_ASSET__fGF5A0_Y__"